'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { TextArea } from '@pickleballinc/react-ui';
import { useForm } from 'react-hook-form';

import { ActionButtons } from '@/components/molecules';
import { EditRegistrationData, editRegistrationSchema } from '@/entities/EditOrganizationModalSchemeData';

interface WithdrawPlayerFormProps {
	onSubmit: (data: EditRegistrationData) => void;
	onClose: () => void;
	isSubmitting: boolean;
}

export const WithdrawPlayerForm = ({ onSubmit, onClose, isSubmitting }: WithdrawPlayerFormProps) => {
	const form = useForm<EditRegistrationData>({
		resolver: zodResolver(editRegistrationSchema),
		defaultValues: {
			comment: ''
		}
	});

	const { formState, register, handleSubmit } = form;

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<p className="pb-1 pt-4 text-xs text-gray-500">Comments:</p>
			<TextArea
				focusColor="orange"
				{...register('comment')}
				className="pt-4"
				placeholder="Enter your comment"
				hasError={!!formState.errors.comment}
				hint={formState.errors.comment?.message?.toString()}
			/>

			<ActionButtons
				className="flex place-self-end !px-[10px] !py-[16px]"
				closeButtonClassName={'w-full !text-gray-700'}
				submitButtonClassName={'w-full !text-white'}
				onClose={onClose}
				submitButtonText="Send"
				closeButtonText="Cancel"
				submitButtonDisabled={formState.isSubmitting || isSubmitting}
			/>
		</form>
	);
};
